import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import useEffectAsync from '../../../hooks/useEffectAsync'
import CommonLineBarChart from '../charts/CommonLineBarChart'
import { useThemeColor } from '../StatisticsPageContent'
import { client } from '../../../client'
import ChartNoData from '../charts/ChartNoData'

const Caseload = () => {
  const { t } = useTranslation('statisticsPage')
  const [data, setData] = useState([])
  const themeColor = useThemeColor()

  useEffectAsync(async () => {
    setData(await client.caseload())
  }, [])

  const title = t('caseload')
  if (!data.length) return <ChartNoData title={title} />

  const mapData = data.map((item) => {
    return {
      name: item.naam,
      caseload: item.caseload
    }
  })

  const resData = {
    rawData: data,
    data: mapData,
    bars: [{ name: 'caseload', color: themeColor }],
    title
  }
  return <CommonLineBarChart data={resData} />
}

export default Caseload
